import React, {useState, useContext} from 'react';
import {Button, Modal} from 'antd';
import CircularLoader from "@common/CircularLoader";
import Alert from "@common/Alert";
import {BrandContext} from "@context/BrandContext";
import ButtonsGroup from "@common/ButtonsGroup";

const SubmitTestConfirm = (props) => {
    const {open = false, isLoading = false, questionsRemaining = 0, testAssignmentResult, onClose, updateTestResults, submitTest} = props;
    const brandConfig = useContext(BrandContext);
    const [isOkDisabled, setOkDisabled] = useState(false);
    const [error, setError] = useState();

    const handleOk =  () => {
        if(isOkDisabled) {
            return;
        }

        return new Promise((resolve, reject) => {
            updateTestResults({submitAnswers: true, onComplete: (data) => {
                submitTest((success) => {
                    if(success) {
                        setOkDisabled(true);
                    } else {
                        setError('There was an error submitting your test. Please try again.');
                    }
                });
                resolve();
            }});
        });
    }

    return <Modal
        title={isOkDisabled ? brandConfig.testName + ' Submitted' : 'Confirm ' + brandConfig.testName + ' Submit'}
        open={open}
        onCancel={onClose}
        footer={() => (
            <ButtonsGroup position={'right'} className={'mediumGap'}>
                <Button onClick={onClose}>
                    Close
                </Button>
                <Button type="primary" onClick={handleOk} disabled={isOkDisabled} loading={isLoading}>
                    Ok
                </Button>
            </ButtonsGroup>
        )}
    >
        {isLoading &&
            <CircularLoader />
        }
        {error &&
            <Alert type="error" message={error}/>
        }
        {(!isLoading && testAssignmentResult === undefined) &&
            <div>
                <p>Are you sure you want to submit your {brandConfig.testName.toLowerCase()} for marking?</p>
                <p>You will not be able to edit your {brandConfig.testName.toLowerCase()}.</p>
                {questionsRemaining > 0 && (
                    <p className="ch-warning-text">
                        You still have {questionsRemaining} unanswered question{questionsRemaining > 1 ? 's' : ''}.
                    </p>
                )}
            </div>
        }

        {(!isLoading && testAssignmentResult !== undefined) &&
            <div>
                <Alert type="success" message="You have completed your test."/>
                {testAssignmentResult.showResult &&
                    <p><strong>Your {brandConfig.testName.toLowerCase()} result:</strong> {testAssignmentResult.mark} out
                        of {testAssignmentResult.maxMark} from {testAssignmentResult.total} questions.</p>
                }
            </div>
        }
    </Modal>
};

export default SubmitTestConfirm;
